import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as appSettingsStore from '..';

export const selectAppSettingsState = createFeatureSelector<appSettingsStore.State>(appSettingsStore.appSettingsStateFeatureKey);
export const selectAppSettingsStateConfig = createSelector (selectAppSettingsState, (state: appSettingsStore.State) => state.config);

